module.exports = __webpack_public_path__ + "media/azelaic-medium.89aae856.mp4";